// 分页组件封装，对外简化交互参数，与交互方法
// TODO: 还没有根据UI设计完成样式定制
import React from 'react';
import { Pagination } from '@alifd/next';

export default ({
  pageInfo = {}, onChange = () => {
  },
}) => {
  const pageNoChange = (pageNo) => {
    if (typeof onChange === 'function') {
      onChange({
        ...pageInfo,
        pageNo,
      });
    }
  };
  const handlePageSizeChange = (pageSize) => {
    if (typeof onChange === 'function') {
      onChange({
        ...pageInfo,
        pageSize,
        pageNo: 1,
      });
    }
  };
  const popupProps = {
    align: 'bl tl',
  };
  return (
    <div
      style={{
        marginTop: '20px',
        textAlign: 'right',
      }}
      className="resetPagination"
    >
      <Pagination
        pageSizeSelector="dropdown"
        pageSizePosition="end"
        popupProps={popupProps}
        total={pageInfo.total}
        current={pageInfo.pageNo}
        pageSize={pageInfo.pageSize}
        pageSizeList={[5, 10, 30, 50, 100]}
        totalRender={(total) => `共${total}条`}
        onChange={pageNoChange}
        onPageSizeChange={handlePageSizeChange}
      />
    </div>
  );
};
